const ITEMS = [
  "People",
  "Passion",
  "Performance",
  "Hospitality Excellence",
  "Europe · Middle East · Asia",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-serif italic font-light text-4xl md:text-6xl text-ink/80 px-8 whitespace-nowrap">
          {item}
        </span>
        <span className="w-2 h-2 rounded-full bg-bronze shrink-0" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-ink/10 bg-ivory py-8"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
